import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = import.meta.env.VITE_BACKEND_URL;

// --- API Client for FormData ---
export const apiClientFormData = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

apiClientFormData.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get("access");

    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["Accept-Language"] = Cookies.get("language") || "en";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// --- API Client for JSON ---
export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get("access");

    if (accessToken && !config.headers["Authorization"]) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["Accept-Language"] = Cookies.get("language") || "en";
    }

    return config;
  },
  (error) => Promise.reject(error)
);
